export const COMPANY = "Aladağ Yazılım A.Ş.";
export const COPYRIGHT = `Tüm hakları ${COMPANY} tarafına aittir, izinsiz kopyalanamaz.`;

export const LEGAL = {
  terms: {
    title: "Kullanım Koşulları",
    body: `Son güncelleme: 2026

1. TARAFLAR VE KAPSAM
İşbu Kullanım Koşulları, ${COMPANY} ("Şirket") tarafından geliştirilen CryptoSense AI Trading Desk yazılımını ("Platform") kullanan gerçek ve tüzel kişileri ("Kullanıcı") kapsar. Platforma kayıt olarak veya kullanarak bu koşulları kabul etmiş sayılırsınız.

2. HİZMETİN NİTELİĞİ
CryptoSense bir yazılım aracıdır. Platform; piyasa verilerini, haber akışlarını ve yapay zekâ analizlerini bir araya getirerek bilgilendirme amaçlı sinyaller, yorumlar ve otomasyon araçları sunar. Platform bir yatırım danışmanlığı hizmeti DEĞİLDİR ve hiçbir çıktısı yatırım tavsiyesi niteliği taşımaz.

3. YATIRIM TAVSİYESİ OLMAMASI
Platform üzerinden üretilen tüm sinyaller, yorumlar, fırsat önerileri ve otomatik işlemler yalnızca bir yazılımın ürettiği istatistiksel/olasılıksal çıktılardır. Bunlar; alım, satım veya elde tutma yönünde bir tavsiye, teşvik veya garanti oluşturmaz. Yatırım kararları tamamen Kullanıcının kendi takdirindedir.

4. SORUMLULUĞUN KULLANICIYA AİT OLMASI
Kripto varlık piyasaları yüksek oynaklık içerir. Kullanıcının Platformu kullanarak veya Platform çıktılarına dayanarak gerçekleştirdiği tüm işlemlerden doğabilecek her türlü kâr ve zararın sorumluluğu münhasıran Kullanıcıya aittir. Şirket, doğrudan veya dolaylı hiçbir maddi/manevi zarardan sorumlu tutulamaz.

5. HESAP GÜVENLİĞİ
Kullanıcı, hesap bilgilerinin, iki adımlı doğrulama (2FA) anahtarlarının ve varsa borsa API anahtarlarının gizliliğinden sorumludur. API anahtarlarında para çekme (withdraw) yetkisinin kapalı tutulması şiddetle önerilir.

6. HİZMET SÜREKLİLİĞİ
Şirket, üçüncü taraf veri sağlayıcılarındaki kesinti, coğrafi erişim engelleri veya teknik nedenlerle hizmetin kesintisiz olacağını garanti etmez.

7. FİKRİ MÜLKİYET
Platforma ilişkin tüm yazılım, tasarım, marka ve içerikler ${COMPANY}'ye aittir ve izinsiz kopyalanamaz, çoğaltılamaz veya dağıtılamaz.

8. DEĞİŞİKLİKLER
Şirket bu koşulları önceden bildirimde bulunarak güncelleyebilir. Güncel koşullar Platform üzerinde yayımlandığı anda yürürlüğe girer.`,
  },
  risk: {
    title: "Risk Feragatnamesi (Disclaimer)",
    body: `KRİPTO VARLIK İŞLEMLERİ YÜKSEK RİSK İÇERİR.

1. Kripto varlıkların fiyatları son derece oynak (volatil) olup kısa sürede önemli ölçüde değer kazanabilir veya kaybedebilir. Yatırdığınız anaparanın tamamını kaybedebilirsiniz.

2. CryptoSense yalnızca bir yazılım aracıdır ve ${COMPANY} tarafından bilgilendirme amacıyla sunulur. Platform, hiçbir koşulda yatırım tavsiyesi vermez, kâr garantisi sunmaz ve gelecekteki performansa dair güvence vermez.

3. Yapay zekâ tarafından üretilen sinyaller, yorumlar ve otomatik bot işlemleri hata payı içerebilir; geçmiş performans gelecekteki sonuçların göstergesi değildir.

4. Kaldıraçlı (futures) işlemler ek riskler barındırır ve teminatınızın tamamının likidite (tasfiye) yoluyla kaybına yol açabilir.

5. Platform üzerinden veya Platform çıktılarına dayanarak yapacağınız tüm işlemlerin ve bunlardan doğacak tüm kâr/zararın sorumluluğu tamamen size aittir.

6. Yalnızca kaybetmeyi göze alabileceğiniz tutarlarla işlem yapmalı ve gerektiğinde bağımsız, yetkili bir finansal danışmana başvurmalısınız.

Bu feragatnameyi onaylayarak yukarıdaki riskleri anladığınızı ve kabul ettiğinizi beyan edersiniz.`,
  },
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    body: `6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU ("KVKK") KAPSAMINDA AYDINLATMA METNİ

1. VERİ SORUMLUSU
Kişisel verileriniz, veri sorumlusu sıfatıyla ${COMPANY} tarafından işlenmektedir.

2. İŞLENEN KİŞİSEL VERİLER
Ad-soyad, e-posta adresi, hesap kimlik bilgileri, iki adımlı doğrulama verileri, işlem/portföy kayıtları ve varsa şifrelenmiş borsa API anahtarları işlenmektedir.

3. İŞLEME AMAÇLARI
Verileriniz; üyelik oluşturma ve yönetimi, hesap güvenliğinin sağlanması, hizmetin sunulması, yasal yükümlülüklerin yerine getirilmesi ve platform performansının iyileştirilmesi amaçlarıyla işlenir.

4. HUKUKİ SEBEP
Verileriniz; sözleşmenin kurulması ve ifası, hukuki yükümlülüklerin yerine getirilmesi ve açık rızanız hukuki sebeplerine dayanılarak işlenir.

5. VERİ GÜVENLİĞİ
Borsa API secret bilgileri veritabanında şifrelenmiş (encrypted) olarak saklanır. Şirket, verilerinizin güvenliği için makul teknik ve idari tedbirleri alır.

6. AKTARIM
Verileriniz, hizmetin sunulması için gerekli olduğu ölçüde yetkili kamu kurumları ve altyapı sağlayıcıları ile mevzuata uygun şekilde paylaşılabilir; pazarlama amacıyla üçüncü taraflara satılmaz.

7. HAKLARINIZ
KVKK'nın 11. maddesi uyarınca; verilerinize erişme, düzeltilmesini veya silinmesini isteme, işlenmesine itiraz etme ve rızanızı geri çekme haklarına sahipsiniz. Taleplerinizi Şirket'e iletebilirsiniz.

Bu metni onaylayarak kişisel verilerinizin yukarıda belirtilen kapsamda işlenmesine açık rıza verdiğinizi beyan edersiniz.`,
  },
};
